import { createScreenOutElement } from "../dom";
import { mouse_key_map } from "_js/keyMouseCode";
import { CROSSHAIR_SHARE_CODE_REG, INVITE_CODE_REG } from "_lib/constants/reg";
import store from "@/store";
import { getAccountInfo } from "_api/account";
import { MPGetAccountInfo } from "_root/miniprogram/team_center/src/api/account";
import EventBus from "../EventBus";
import { replaceImgTagWithAltText } from "./utilsStr";
import { readBuffer } from "./utilsFile";
import Vue from "vue";
import router from "@/router";
import { reportRecentUserMp } from "_api/miniprogram";
import { checkLegalInviteCode } from "_api/invite";
import { IM_MSG_TYPE, MESSAGE_CONTENT_COMPONENT } from '_lib/constants/IM';
import { MESSAGE_COMPONENT_TYPE } from '_lib/constants/message-cpt';
let electron_store_set_promises = []

let getMachineIdPromise = null

export const getParams = function (url) {
  var url = url || window.location.search;
  if (url.indexOf("?") < 0) {
    return false;
  }
  return url.match(/([^?=&]+)(=([^&]*))/g).reduce(function (a, v) {
    return (a[v.slice(0, v.indexOf("="))] = v.slice(v.indexOf("=") + 1)), a;
  }, {});
};
// 拿到url中的具体某个参数的值
export const getUrlParam = function (key, url) {
  var url = url ? new URL(url).search : window.location.search;
  var params = getParams(url);
  return params[key] ? params[key] : "";
};

export function setUrlParam(url = window.location.href, params = {}) {
  const urlObj = new URL(url);
  Object.keys(params).forEach(key => {
    if (params[key] !== undefined) {
      urlObj.searchParams.append(key, params[key]);
    }
  });
  return urlObj.toString();
}

// cookie操作，因网页改为protocol加载，故将cookie操作改为storage
// NEXT VERSION
// 下个版本需将getCookie和delCookie方法中Cookie相关的移除
export function setCookie(key, val) {
  if (val === undefined) return;
  localStorage.setItem(key, JSON.stringify(val));
}
export function getCookie(key) {
  const jsonStr = localStorage.getItem(key);
  if (!jsonStr) return null;
  try {
    let ck = JSON.parse(jsonStr);
    if (ck) {
      return ck;
    } else {
      const arr = document.cookie.match(
        new RegExp("(^| )" + key + "=([^;]*)(;|$)")
      );
      if (arr != null) {
        return unescape(arr[2]);
      } else {
        return null;
      }
    }
  } catch (e) {
    return null;
  }
}
export function delCookie(key) {
  localStorage.removeItem(key);

  let now = new Date();
  now.setTime(now.getTime() - 100000);
  const cval = getCookie(key);
  if (cval != null) {
    document.cookie =
      key +
      "=;expires=" +
      now.toGMTString() +
      ";path=/;domain=" +
      process.env.BASE_DOMAIN;
  }
}
// 持久储存操作: 客户端存本地，web存localStorage
export function setStorage(key, val) {
  if (window.client_env === "electron" && window.electronAPI.setData) {
    const set_promise = window.electronAPI.setData(key, JSON.stringify(val));
    electron_store_set_promises.push(set_promise.finally(() => {
      electron_store_set_promises = electron_store_set_promises.filter(p => p !== set_promise)
    }))
  } else {
    localStorage.setItem(key, JSON.stringify(val));
  }
}
// 客户端缓存数据存储入leveldb，web存localStorage
export async function setCacheStorage(key, val) {
  if (window.client_env === "electron" && window.electronAPI.setCacheData) {
    await window.electronAPI.setCacheData(key, JSON.stringify(val));
  } else {
    await localStorage.setItem(key, JSON.stringify(val));
  }
}
export async function getStorage(key) {
  if (window.client_env === "electron" && window.electronAPI.getData) {
    if (electron_store_set_promises.length > 0) {
      await Promise.all(electron_store_set_promises)
    }
    let d = await window.electronAPI.getData(key);
    return d;
  } else {
    return JSON.parse(localStorage.getItem(key));
  }
}
export async function getCacheStorage(key) {
  if (window.client_env === "electron" && window.electronAPI.getCacheData) {
    let d = await window.electronAPI.getCacheData(key);
    return d;
  } else {
    return JSON.parse(localStorage.getItem(key));
  }
}
// 获取持久化setting_data
export async function getSettingData() {
  let data = await getStorage("hcsd");
  // 如果可以获取到hcsd，并且没有is_mic_level_update_v2，有micLevel，
  // 说明是老版本更新，需要调整micLevel
  if (data && !data.is_mic_level_update_v2 && data.micLevel) {
    if (data.micLevel === 100) {
      // 如果之前是100，认为没调整过，设置micLevel为120
      data.micLevel = 120;
    } else {
      // 其余情况，麦克风音量调整为150，
      data.micLevel = Math.min(parseInt(data.micLevel * 1.5), 150);
    }
    data.is_mic_level_update_v2 = true;
  }
  return data;
}
export function delStorage(key) {
  if (window.client_env === "electron" && window.electronAPI.delData) {
    window.electronAPI.delData(key);
  } else {
    localStorage.removeItem(key);
  }
}
export function delCacheStorage(key) {
  if (window.client_env === "electron" && window.electronAPI.delCacheData) {
    window.electronAPI.delCacheData(key);
  } else {
    localStorage.removeItem(key);
  }
}
export function throttle(fn, wait) {
  let timer = null;
  return function () {
    let _this = this;
    let args = arguments;
    
    if (!timer) {
      timer = setTimeout(function () {
        fn.apply(_this, args);
        timer = null;
      }, wait);
    }
  };
}

export function debounce(func, wait) {
  let timer;
  return function () {
    let _this = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      func.apply(_this, args);
    }, wait);
  };
}
export async function getSmDeviceId() {
  if (window._initSmPromise) {
    try {
      await window._initSmPromise
    } catch (err) {
      console.error(err)
    }
  }
  return await window.dealSmDeviceId && window.dealSmDeviceId()
}
export function getBrowserType() {
  if (window && window.navigator.userAgent) {
    const ua = window.navigator.userAgent.toLocaleLowerCase();
    let browserType = "";
    if (ua.match(/msie/) != null || ua.match(/trident/) != null) {
      browserType = "IE";
    } else if (ua.match(/edg|edge/) != null) {
      browserType = "Edge";
    } else if (ua.match(/firefox/) != null) {
      browserType = "firefox";
    } else if (ua.match(/ucbrowser/) != null) {
      browserType = "UC";
    } else if (ua.match(/opera/) != null || ua.match(/opr/) != null) {
      browserType = "opera";
    } else if (ua.match(/baidubrowser/) != null) {
      browserType = "baidu";
    } else if (ua.match(/metasr/) != null) {
      browserType = "sougou";
    } else if (
      ua.match(/tencenttraveler/) != null ||
      ua.match(/qqbrowse/) != null
    ) {
      browserType = "QQ";
    } else if (ua.match(/maxthon/) != null) {
      browserType = "maxthon";
    } else if (ua.match(/lbbrowser/) != null) {
      browserType = "liebao";
    } else if (ua.match(/2345explorer/) != null) {
      browserType = "2345";
    } else if (ua.match(/qihu 360ee/) != null) {
      browserType = "360";
    } else if (ua.match(/chrome/) != null) {
      browserType = "Chrome";
    } else if (ua.match(/safari/) != null) {
      browserType = "Safari";
    }
    return browserType;
  }
}
// 获取鼠标键盘code对应的展示名称
// @param {Array} v
export function getKeyCodeName(v, type = "string", join = "+", errorCb) {
  if (!v) {
    return "";
  }
  try {
    let additionKey = [16, 17, 18];
    let l = JSON.parse(JSON.stringify(v));
    l.sort((a, b) => {
      if (additionKey.includes(a)) {
        if (a === 17) {
          a -= 100;
        }
        a -= 18;
      }
      if (additionKey.includes(b)) {
        if (b === 17) {
          b -= 100;
        }
        b -= 18;
      }
      return a - b;
    });
    l = l.map((v) => {
      let key_name = mouse_key_map[v];
      return key_name || `Key Code ${v}`;
    });
    if (type === "list") {
      return l;
    } else {
      return l.join(join);
    }
  } catch (e) {
    errorCb && errorCb();
  }
}

// 在app外执行协议
export function executeProtocolOutApp(protocol, protocolPrefix = 'heybox') {
  const ua = window.navigator.userAgent.toLowerCase();
  const client_type = getUrlParam("client_type");

  // - 若是 JSON 协议（对象或 JSON 字符串）则一律使用 heybox://
  // - 已经是完整 URI（heybox:// 或 heyboxchat://，含编码形式）则保持不变
  const isObjectProtocol = typeof protocol === 'object' && protocol !== null;
  const isJSONString = typeof protocol === 'string' && /^\s*[\[{]/.test(protocol);
  const isPreformattedURI = typeof protocol === 'string' && /^(heybox|heyboxchat):\/\//i.test(protocol);
  const isPreformattedEncodedURI = typeof protocol === 'string' && /^(heybox|heyboxchat)%3A%2F%2F/i.test(protocol);

  const protocolEndpoint = protocolPrefix === 'heyboxchat' ? 'hc_protocol' : 'hb_protocol';

  // 安卓环境下，当 protocolPrefix 为 heyboxchat 时用新增协议
  const isAndroidHeyboxchat = /Android/i.test(ua) && protocolPrefix === 'heyboxchat';

  let formatProtocol = '';
  let processedProtocol = '';

  if (isPreformattedURI || isPreformattedEncodedURI) {
    formatProtocol = protocol;
    processedProtocol = protocol;
  } else {
    const forceHeyboxScheme = isObjectProtocol || isJSONString;
    const scheme = forceHeyboxScheme ? 'heybox' : protocolPrefix;

    if (isObjectProtocol) {
      processedProtocol = encodeURIComponent(JSON.stringify(protocol));
      formatProtocol = `${scheme}://` + processedProtocol;
    } else if (isJSONString) {
      const jsonStr = protocol.trim();
      processedProtocol = encodeURIComponent(jsonStr);
      formatProtocol = `${scheme}://` + processedProtocol;
    } else {
      processedProtocol = encodeURIComponent(String(protocol));
      formatProtocol = `${scheme}://` + processedProtocol;
    }
  }

  if (/QQ/i.test(ua) || /Weibo/i.test(ua) || /Android/i.test(ua)) {
    if (isAndroidHeyboxchat) {
      window.location.href = "https://api.xiaoheihe.cn/open_inapp/#heyboxchat://redirect-to-heybox/?protocol=" + processedProtocol;
    } else {
      window.location.href = "https://api.xiaoheihe.cn/open_inapp/#" + formatProtocol;
    }
  } else {
    const host = client_type == "acc_mobile" ? "acc.xiaoheihe.cn" : "c.xiaoheihe.cn";
    window.location.href = "https://" + host + "/" + protocolEndpoint + "?protocol=" + formatProtocol;
  }
}

/**
 * @function 获取多个异步请求的完成情况
 * @param Promises {Array} 参数为async异步方法的返回的Promise数组，且每个异步函数的返回值必须为boolean
 * @param trueRestrict 布尔值 默认为false，用于判断是否校验返回值为true
 */
export async function getAsyncRequestFinishStatus(
  Promises,
  trueRestrict = false
) {
  const res = await Promise.all(Promises);
  if (trueRestrict) {
    return res.every((item) => item); // 判断请求是否都正确返回
  }
  return true;
}

// 根据模板语法替换对象中数据并生成html, 默认模板为{key}
export function formatTempText(str, obj, template = /\/|\$\{(\w+)\}/g) {
  return str?.replace(template, function (match, p1) {
    if (match == "/") {
      return `<span>/</span>`;
    }
    return `<span>${obj[p1]}</span>`;
  });
}

// 获取ua中的接口base路由
export function extractAPIValues() {
  if (window._API_HOST_VALUES) {
    return window._API_HOST_VALUES;
  }
  if (window.client_env === "electron") {
    const regex = /BASE_API\/([^ ]+) BASE_HEYBOX_API\/([^ ]+)/;
    const matches = window.navigator.userAgent.match(regex);
    if (matches && matches.length === 3) {
      const baseAPI = decodeURIComponent(matches[1]);
      const baseHeyboxAPI = decodeURIComponent(matches[2]);
      window._API_HOST_VALUES = {
        BASE_API: baseAPI || "https://chat.xiaoheihe.cn",
        BASE_XHH: baseHeyboxAPI || "https://api.xiaoheihe.cn",
        WS_BASE: baseAPI
          ? baseAPI.replace("https", "wss")
          : "wss://chat.xiaoheihe.cn",
      };
    } else {
      window._API_HOST_VALUES = {
        BASE_API: "https://chat.xiaoheihe.cn",
        BASE_XHH: "https://api.xiaoheihe.cn",
        WS_BASE: "wss://chat.xiaoheihe.cn",
      };
    }
  } else {
    window._API_HOST_VALUES = {
      BASE_API: process.env.BASE_API,
      BASE_XHH: process.env.BASE_XIAOHEIHE_API,
      WS_BASE: "wss://" + window.location.host,
    };
  }
  return window._API_HOST_VALUES;
}

export function getExeVersion() {
  if (window._EXE_VERSION !== undefined) {
    return window._EXE_VERSION;
  }
  let EXE_VERSION = "";
  if (window.client_env === "electron") {
    const regex = /EXE_VERSION\/([^ ]+)/;
    const matches = window.navigator.userAgent.match(regex);
    if (matches && matches.length === 2) {
      EXE_VERSION = decodeURIComponent(matches[1]);
    }
  }
  window._EXE_VERSION = EXE_VERSION;
  return window._EXE_VERSION;
}

export function electronVersionAfter30() {
  return compareVersions(process.versions.electron, '30.0.0') >= 0
}

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function formatSecond(val) {
  return val >= 1000 ? `${(val / 1000).toFixed(2)}s` : `${val}ms`;
}

export function formatSecondsToHours(seconds) {
  let hours = seconds / 3600;  // Convert seconds to hours
  if (hours < 100) {
    return Math.max(Math.round(hours * 10) / 10, 0.1);  // Round to 1 decimal place, ensure it is at least 0.1
  } else {
    return Math.floor(hours);  // Round to nearest integer for hours >= 100
  }
}

export async function checkIsInviteCode(invite_url) {
  if (!invite_url) return false;
  if (/^\d+$/.test(invite_url) || /^i\w+$/.test(invite_url)) {
    return invite_url;
  }
  const matches = invite_url.match(INVITE_CODE_REG);
  if (matches) {
    for (let match of matches) {
      let code = match.split("/").pop();
      if (/^\d+$/.test(code) || /^i\w+$/.test(code)) {
        return code;
      }
    }
  }
  let res = await checkLegalInviteCode(
    { _notip: true },
    { invite_code: invite_url }
  );
  const { status, result } = res.data;
  if (status === "ok" && result.available) {
    return invite_url
  }
  return false;
}

export function previousTimeFormat(updateTimeStamp) {
  const currentTimeStamp = Date.now();
  const timeDiffInSeconds = Math.floor(
    (currentTimeStamp - updateTimeStamp) / 1000
  );

  // 根据时间差值范围设置显示格式
  if (timeDiffInSeconds < 0) {
    return "现在";
  } else if (timeDiffInSeconds < 60) {
    // 不到一分钟
    return `${timeDiffInSeconds}秒前`;
  } else if (timeDiffInSeconds < 3600) {
    // 不到一小时
    const minutes = Math.floor(timeDiffInSeconds / 60);
    return `${minutes}分钟前`;
  } else if (timeDiffInSeconds < 86400) {
    // 不到一天
    const hours = Math.floor(timeDiffInSeconds / 3600);
    return `${hours}小时前`;
  } else {
    // 超过一天
    const days = Math.floor(timeDiffInSeconds / 86400);
    return `${days}天前`;
  }
}

export function getRandom(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function browserDownloadFile(downloadLink, dlownloadName = "") {
  const link = document.createElement("a");
  link.href = downloadLink;
  link.download = dlownloadName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

let loginPromise = null;

export async function checkLoginStatusAsync(not_show_login) {
  if (loginPromise) {
    return loginPromise;
  }
  const currentLoginPromise = new Promise(async (resolve, reject) => {
    try {
      const getAccountInfoFun = Vue.prototype.isMiniProgram ? MPGetAccountInfo : getAccountInfo
      const handleNonLoggedIn = () => {
        if(!not_show_login && !store.getters.init_net_error) {
          EventBus.$dynamic("Login");
        }
        resolve(false);
      }
      let res = await getAccountInfoFun({ _notip: true });
      res = res.data || res
      const { status, result } = res
      if (status === "ok") {
        const { account_detail: d } = result;
        if (getCookie("new_user_id") == d.userid) {
          setCookie("new_user_id", "");
        }
        setCookie("heybox_id", d.userid);
        setCookie("nickname", d.username);
        setCookie("avatar", d.avatar);
        setCookie("level", d.level_info.level);
        store.commit("SET_USER_INFO", {
          user_id: d.userid,
          nickname: d.username,
          avatar: d.avatar,
          avatar_decoration: d.avatar_decoration || {},
          chat_intro: result.profile?.chat_intro || "",
          count_change_nickname: result.profile?.count_change_nickname || 0,
          level: d.level_info.level,
        });
        if (window.client_env === "electron" && !Vue.prototype.isMiniProgram && window.electronAPI) {
          setTimeout(() => {
            window.electronAPI.notifyLogin(store.getters.user_info);
          });
        }
        resolve(true);
      } else {
        handleNonLoggedIn();
      }
    } catch (_) {
      handleNonLoggedIn();
    }
  });
  loginPromise = currentLoginPromise;
  return loginPromise;
}

export function getEmojiClass(emoji) {
  const class_name = emoji.class;
  const code = emoji.code;
  if (!class_name || !code) return "";
  const type = class_name.split("hb-emoji-")[1];
  return ["hb-emoji", class_name, type + "-" + code];
}

export function checkByByte(headers) {
  return (buffers, options = { offset: 0, length: headers.length }) => {
    if (options.offset + options.length > buffers.length) {
      return false;
    }
    return headers.every(
      (header, index) =>
        index < options.length && header === buffers[options.offset + index]
    );
  };
}

export async function isUploadImageLegal(file) {
  const buffers = await readBuffer(file, 0, 8);
  const uint8Array = new Uint8Array(buffers);
  const pngHex = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a];
  const jpgHex = [0xff, 0xd8, 0xff, 0xe0];
  const jpegHex = [0xff, 0xd8, 0xff, 0xe1];
  const gifHex = [0x47, 0x49, 0x46, 0x38];

  const isGif = checkByByte(gifHex)(uint8Array, {
    offset: 0,
    length: gifHex.length,
  });
  if (isGif) return false;

  const isPng = checkByByte(pngHex)(uint8Array, {
    offset: 0,
    length: pngHex.length,
  });
  // 检查是否有 APNG 动画
  const CHUNK_HEADER_LENGTH = 8; // 每个块的头部长度（长度+类型+CRC）
  const HEADER_LENGTH = 8; // PNG文件头部长度
  const checkAPNG = async () => {
    let position = HEADER_LENGTH;
    while (position < file.size) {
      // 读取块的长度和类型
      const chunkHeaderBuffer = await readBuffer(
        file,
        position,
        position + CHUNK_HEADER_LENGTH
      );
      const chunkHeaderArray = new Uint8Array(chunkHeaderBuffer);
      const chunkLength =
        (chunkHeaderArray[0] << 24) |
        (chunkHeaderArray[1] << 16) |
        (chunkHeaderArray[2] << 8) |
        chunkHeaderArray[3];
      const chunkType = chunkHeaderArray.subarray(4, 8);
      position += CHUNK_HEADER_LENGTH;
      // 检查 `acTL` 块
      if (
        Array.from(chunkType).every(
          (val, index) => val === "acTL".charCodeAt(index)
        )
      ) {
        return true; // 发现 `acTL` 块，可能是APNG
      }
      // 跳过块数据和CRC校验码
      position += chunkLength + 4; // 块数据长度 + CRC长度
    }
    return false;
  };
  const isAPNG = isPng ? await checkAPNG() : false;
  if (isPng) return !isAPNG;

  const isJpg = checkByByte(jpgHex)(uint8Array, {
    offset: 0,
    length: jpgHex.length,
  });
  if (isJpg) return true;

  const isJpeg = checkByByte(jpegHex)(uint8Array, {
    offset: 0,
    length: jpegHex.length,
  });
  if (isJpeg) return true;

  return false;
}

// 检测客户端是否开启的函数
export async function checkClientIsOpen(invite_code, web_token) {
  let port = 7888;
  let retryTimes = 0;
  const maxRetries = 3;

  while (retryTimes < maxRetries) {
    try {
      const controller = new AbortController();
      // 实际本地请求速度大概 10ms 之内完成
      const timeoutId = setTimeout(() => controller.abort(), 100);

      const response = await fetch(`http://127.0.0.1:${port}/show_invite_send?invite_code=${invite_code}&web_token=${web_token}`, {
        signal: controller.signal
      });

      clearTimeout(timeoutId);
      const res = await response.json();
      if (res.status === 'ok') {
        return true;
      } else {
        throw new Error('Client not found');
      }
    } catch (error) {
      // 连接失败，尝试下一个端口
      retryTimes++;
      port++;
      
      // 如果是最后一次重试，返回 false
      if (retryTimes >= maxRetries) {
        return false;
      }
    }
  }
  
  return false;
}

export function getOSType() {
  if (window && window.navigator.userAgent) {
    const ua = window.navigator.userAgent.toLocaleLowerCase();
    if (/(iphone|ipad|ios)/i.test(ua)) {
      return "iOS";
    } else if (/mac os/i.test(ua)) {
      return "Mac";
    } else if (/(android|harmony)/i.test(ua)) {
      return "Android";
    } else {
      return "Windows";
    }
  }
  return "";
}
export async function copyText(text) {
  const fallback = () => {
    console.log('[copy text] use fallback, reason:', JSON.stringify({
      navigator: !!navigator.clipboard,
      isSecureContext: window.isSecureContext,
    }));
    var element = createScreenOutElement(text);
    element.focus();
    element.select();
    element.setSelectionRange(0, element.value.length);
    document.execCommand("copy");
    element.remove();
  }

  if(navigator.clipboard && window.isSecureContext) {
    console.log('[copy text] use navigator');
    try {
      await navigator.clipboard.writeText(text)
      window.electronAPI && window.electronAPI.addUsedInviteCode &&
      window.electronAPI.addUsedInviteCode(await checkIsInviteCode(text));
    } catch (err) {
      fallback();
    }
  } else {
    fallback();
  }

}
export function copyRichText(richText) {
  // 将富文本中的 img 标签替换成 alt
  let text = replaceImgTagWithAltText(richText, "text").trim();
  // 将修改后的内容放入剪贴板
  let temp = createScreenOutElement(text);
  document.body.appendChild(temp);
  setTimeout(() => {
    temp.select();
    console.log("copy text", temp.value);
    document.execCommand("copy");
    document.body.removeChild(temp);
  }, 20);
}
export async function copyImage(imageUrl) {
  const img = new Image();
  img.src = imageUrl;
  img.crossOrigin = "anonymous";
  await new Promise((resolve, reject) => {
    img.onload = resolve;
    img.onerror = reject;
  });
  const canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);
  const dataUrl = canvas.toDataURL();
  try {
    await navigator.clipboard.write([
      new ClipboardItem({ "image/png": await (await fetch(dataUrl)).blob() }),
    ]);
    console.log("Image copied to clipboard.");
  } catch (err) {
    console.error("Failed to copy image: ", err);
  }
}

export function formatePostDate (time) {
  if (isNaN(Number(time))) {
    return false
  }
  if (~~time == 0) {
    time = new Date(t.replace(/\s/g, 'T')).getTime() / 1000
    time -= 60 * 60 * 8
  }
  var timeSpan = time * 1000
  var dateTime = new Date(parseInt(timeSpan));
  var year = dateTime.getFullYear();
  var month = dateTime.getMonth() + 1;
  var day = dateTime.getDate();

  var now = new Date();
  var now_new = Date.parse(now)
  var ms = now_new - timeSpan
  var timeSpanStr

  var time_suffix

  if (ms >= 0) {
    time_suffix = '前'
  } else {
    ms = Math.abs(ms)
    time_suffix = '后'
  }

  if (ms <= 1000 * 60 * 1) {
    timeSpanStr = Math.round(ms / 1000) + '秒' + time_suffix
  } else if (1000 * 60 * 1 < ms && ms <= 1000 * 60 * 60) {
    timeSpanStr = Math.round((ms / (1000 * 60))) + '分钟' + time_suffix
  } else if (1000 * 60 * 60 * 1 < ms && ms <= 1000 * 60 * 60 * 24) {
    timeSpanStr = Math.round(ms / (1000 * 60 * 60)) + '小时' + time_suffix
  } else if (1000 * 60 * 60 * 24 < ms && ms <= 1000 * 60 * 60 * 24 * 7) {
    timeSpanStr = Math.round(ms / (1000 * 60 * 60 * 24)) + '天' + time_suffix
  } else {
    timeSpanStr = year + '-' + month + '-' + day
  }
  return timeSpanStr
}

export function IMTimeFormat(
  timestamp,
  show_hour = true,
  previous_time = true
) {
  if (!timestamp) return;
  if (!["string", "number"].includes(typeof timestamp)) return;
  const timestampLength = timestamp.toString().length;
  timestamp = parseInt(timestamp);
  if (timestampLength === 10) {
    timestamp = timestamp * 1000;
  }
  const days = ["日", "一", "二", "三", "四", "五", "六"];
  let time = new Date();
  let ye = time.getFullYear();
  let mo = time.getMonth() + 1;
  let da = time.getDate();
  let week = time.getDay();
  let todayStartPoint = new Date(`${ye}/${mo}/${da} 00:00:00`).getTime();
  let yesterdayStartPoint = todayStartPoint - 24 * 60 * 60 * 1000;
  let tomorrowStartPoint = todayStartPoint + 24 * 60 * 60 * 1000;
  let thisWeekStartPoint =
    new Date(`${ye}/${mo}/${da} 00:00:00`).getTime() -
    week * 24 * 60 * 60 * 1000;
  let thisYearStartPoint = new Date(`${ye}/1/1 00:00:00`).getTime();

  let currentTimtstamp = time.getTime();
  let tarDate = previous_time
    ? new Date(Math.min(timestamp, currentTimtstamp))
    : new Date(timestamp);
  let t_ye = tarDate.getFullYear();
  let t_mo = tarDate.getMonth() + 1;
  let t_da = tarDate.getDate();
  let t_week = tarDate.getDay();
  let t_hour = tarDate.getHours();
  let t_minute = tarDate.getMinutes();
  t_minute = t_minute < 10 ? "0" + t_minute : t_minute;
  let res = "";
  if (timestamp < thisYearStartPoint) {
    res = `${t_ye}年${t_mo}月${t_da}日 ${
      show_hour ? t_hour + ":" + t_minute : ""
    }`;
  } else if (timestamp < thisWeekStartPoint) {
    res = `${t_mo}月${t_da}日 ${show_hour ? t_hour + ":" + t_minute : ""}`;
  } else if (timestamp < yesterdayStartPoint) {
    res = `星期${days[t_week]} ${show_hour ? t_hour + ":" + t_minute : ""}`;
  } else if (timestamp < todayStartPoint) {
    res = `昨天 ${t_hour}:${t_minute}`;
  } else if (timestamp > tomorrowStartPoint) {
    res = `${t_mo}月${t_da}日 ${t_hour}:${t_minute}`;
  } else {
    res = `${t_hour}:${t_minute}`;
  }
  return res;
}

// 时间转换成 年/月/日 时:分 格式
export function timeFormat(timestamp, show_date = true) {
  if (!timestamp) return;
  if (!["string", "number"].includes(typeof timestamp)) return;
  const timestampLength = timestamp.toString().length;
  timestamp = parseInt(timestamp);
  if (timestampLength === 10) {
    timestamp = timestamp * 1000;
  }
  let time = new Date(timestamp);
  let ye = time.getFullYear();
  let mo = time.getMonth() + 1;
  let da = time.getDate();
  let hour = time.getHours();
  let minute = time.getMinutes();
  hour = hour < 10 ? "0" + hour : hour;
  minute = minute < 10 ? "0" + minute : minute;
  let res = (show_date ? `${ye}年${mo}月${da}日` : "") + `${hour + ":" + minute}`;
  return res;
}
// 传入秒数，输入剩余dd天hh:mm:ss
export function formatLeftTime(seconds) {
  // 计算天、小时、分钟和秒
  if (!seconds) {
    return "";
  }
  const days = Math.floor(seconds / (3600 * 24));
  seconds -= days * 3600 * 24;
  const hrs = Math.floor(seconds / 3600);
  seconds -= hrs * 3600;
  const mnts = Math.floor(seconds / 60);
  seconds -= mnts * 60;

  // 构造格式化的时间字符串
  let timeString = "";
  if (days > 0) {
    timeString += `${days}天`;
  }
  if (hrs > 0) {
    // 如果小时数为一位数，在前面补0
    timeString += `${hrs.toString().padStart(2, "0")}:`;
  }
  if (mnts > 0 || timeString.length > 0) {
    // 如果有小时或天要显示，分钟即使为0也要显示
    // 如果分钟数为一位数，在前面补0
    timeString += `${mnts.toString().padStart(2, "0")}:`;
  }
  // 如果有分钟或更大的单位，则秒数总是显示且为两位数，否则显示"xx秒"
  if (timeString.length > 0) {
    timeString += seconds.toString().padStart(2, "0");
  } else {
    timeString = `${seconds}秒`;
  }

  return timeString;
}
export function formatRelativeTime(start, end) {
  const msPerSecond = 1000;
  const msPerMinute = 45 * msPerSecond;
  const msPerHour = 45 * msPerMinute;
  const msPerDay = 22 * msPerHour;
  const msPerMonth = 28 * msPerDay;
  const msPerYear = 345 * msPerDay;

  let delta = end - start;
  let relativeTime = "";

  if (delta < 0) {
    delta = -delta; // Take absolute value for past dates
  }
  let suffix = start < end ? "前" : "后";
  if (delta < msPerMinute) {
    relativeTime = "刚刚";
  } else if (delta < msPerHour) {
    const minutes = Math.round(delta / msPerMinute);
    relativeTime = minutes + " 分钟" + suffix;
  } else if (delta < msPerDay) {
    const hours = Math.round(delta / msPerHour);
    relativeTime = hours + " 小时" + suffix;
  } else if (delta < msPerMonth) {
    const days = Math.round(delta / msPerDay);
    relativeTime = days + " 天" + suffix;
  } else if (delta < msPerYear) {
    const months = Math.round(delta / msPerMonth);
    relativeTime = months + " 月" + suffix;
  } else {
    const years = Math.round(delta / msPerYear);
    relativeTime = years + " 年" + suffix;
  }

  return relativeTime;
}

export function deepCopy(data) {
  let dataTmp = undefined;
  if (data === null || !(typeof data === "object")) {
    dataTmp = data;
  } else {
    dataTmp = data.constructor.name === "Array" ? [] : {};
    for (let key in data) {
      dataTmp[key] = deepCopy(data[key]);
    }
  }
  return dataTmp;
}
// y轴先快后慢滚动到指定位置
export function easeOutScrollTo(position = 0, el = null) {
  return new Promise((resolve) => {
    // 不存在原生requestAnimationFrame，用setTimeout模拟替代
    if (!window.requestAnimationFrame) {
      window.requestAnimationFrame = function (cb) {
        return setTimeout(cb, 17);
      };
    }
    // 当前滚动高度
    var scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    if (el) {
      // 容器内滚动情况
      scrollTop = el.scrollTop;
    }
    var step = function () {
      const distance = position - scrollTop;
      scrollTop = scrollTop + distance / 5;
      if (Math.abs(distance) < 1) {
        if (el) {
          el.scrollTo(0, position);
        } else {
          window.scrollTo(0, position);
        }
        // 滚动结束
        setTimeout(() => {
          resolve(1);
        }, 18);
      } else {
        if (el) {
          el.scrollTo(0, scrollTop);
        } else {
          window.scrollTo(0, scrollTop);
        }
        requestAnimationFrame(step);
      }
    };
    step();
  });
}

export function formatDuration(duration, calHour = false) {
  if (isNaN(duration)) {
    throw new Error("Invalid input. Expected a number.");
  }
  if (Number(duration) > 0 && Number(duration) < 1) {
    return '00:01'
  }

  if (calHour) {
    const hours = Math.floor(duration / 3600);
    const minutes = Math.floor((duration % 3600) / 60);
    const secs = duration % 60;
    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(secs).padStart(2, "0");

    if (hours > 0) {
      return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    } else {
      return `${formattedMinutes}:${formattedSeconds}`;
    }
  } else {
    let totalSeconds = Math.floor(duration);
    let minutes = Math.floor(totalSeconds / 60);
    let remainingSeconds = totalSeconds % 60;

    return (
      String(minutes).padStart(2, "0") +
      ":" +
      String(remainingSeconds).padStart(2, "0")
    );
  }
}

export function JSONParse(str, defaultValue = {}) {
  if (str === undefined) return defaultValue;
  if (typeof str !== "string") return str;
  try {
    return JSON.parse(str);
  } catch (e) {
    return defaultValue;
  }
}
export function watchElementSize(element, callback, nextTick = true) {
  if (!element) return;
  const observer = new ResizeObserver((entries) => {
    if (nextTick) {
      requestAnimationFrame(() => {
        for (let entry of entries) {
          callback(entry.contentRect);
        }
      });
    } else {
      for (let entry of entries) {
        callback(entry.contentRect);
      }
    }
  });

  observer.observe(element);

  return observer; // 返回 ResizeObserver 实例，方便后续取消监听
}
// 判断版本新旧
export function compareVersions(version1, version2) {
  const arr1 = version1.split(".").map(Number);
  const arr2 = version2.split(".").map(Number);

  for (let i = 0; i < Math.max(arr1.length, arr2.length); i++) {
    const num1 = arr1[i] || 0;
    const num2 = arr2[i] || 0;

    if (num1 < num2) {
      return -1; // version1 < version2
    } else if (num1 > num2) {
      return 1; // version1 > version2
    }
  }

  return 0; // version1 = version2
}
export function generateRandomString(length) {
  let characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";

  for (let i = 0; i < length; i++) {
    let randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  return result;
}
// 页面可见性变化监听
export function addPageVisibilityChangeListener(
  enterCallback = () => {},
  leaveCallback = () => {}
) {
  var state, visibilityChange;
  if (typeof document.hidden !== "undefined") {
    visibilityChange = "visibilitychange";
    state = "visibilityState";
  } else if (typeof document.mozHidden !== "undefined") {
    visibilityChange = "mozvisibilitychange";
    state = "mozVisibilityState";
  } else if (typeof document.msHidden !== "undefined") {
    visibilityChange = "msvisibilitychange";
    state = "msVisibilityState";
  } else if (typeof document.webkitHidden !== "undefined") {
    visibilityChange = "webkitvisibilitychange";
    state = "webkitVisibilityState";
  }
  document.addEventListener(
    visibilityChange,
    function () {
      if (document[state] == "visible") {
        // 回来页面
        setTimeout(() => {
          enterCallback();
        }, 50);
      }
      if (document[state] == "hidden") {
        // 离开页面
        leaveCallback();
      }
    },
    false
  );
}
export function formatNumber(num) {
  num = Number(num);
  if (num > 100000) {
    return Math.round(num / 10000) + "w";
  } else if (num > 10000) {
    return Math.round(num / 1000) + "k";
  } else {
    return num.toString();
  }
}
export function handleReplaceHtmlTag(inputString, excludeAttr = "") {
  if (!inputString) return "";
  // 如果不需要排除属性，则直接转义
  if (!excludeAttr) {
    return inputString.replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
  // 创建一个容器元素来包含输入的 HTML 字符串
  const container = document.createElement("div");
  container.innerHTML = inputString;
  const excludeAttrArray = excludeAttr.split(",");
  const checkHasAttr = (node) => {
    return excludeAttrArray.some(attr => node.hasAttribute(attr))
  }
  // 递归地处理每个节点，进行转义或保留
  function processNode(node) {
    // 检查节点是否是元素节点
    if (node.nodeType === 1) {
      // 检查元素是否包含排除属性，如果包含，直接返回其 outerHTML
      if (checkHasAttr(node)) {
        return node.outerHTML;
      } else {
        // 构造转义后的标签开头
        let result = `&lt;${node.tagName.toLowerCase()}`;
        Array.from(node.attributes).forEach((attr) => {
          result += ` ${attr.name}="${attr.value.replace(/"/g, "&quot;")}"`;
        });
        result += "&gt;";

        // 递归处理所有子节点
        node.childNodes.forEach((child) => {
          result += processNode(child);
        });

        // 添加转义后的标签结尾
        result += `&lt;/${node.tagName.toLowerCase()}&gt;`;
        return result;
      }
    } else if (node.nodeType === 3) {
      // 如果是文本节点，转义特殊字符
      return node.nodeValue.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }

    // 默认返回空字符串
    return "";
  }

  // 处理容器中的每个子节点，并构建最终的结果字符串
  let result = "";
  Array.from(container.childNodes).forEach((child) => {
    result += processNode(child);
  });

  return result;
}
export function webpFormat(urlObj, quality) {
  return new Promise((resolve) => {
    if (window.SUPPORT_WEBP) {
      urlObj = formatWebpParams(urlObj, quality);
      resolve(urlObj);
    } else {
      var img = new Image();
      img.onload = function () {
        var result = img.width > 0 && img.height > 0;
        if (result) {
          window.SUPPORT_WEBP = true;
          urlObj = formatWebpParams(urlObj, quality);
        }
        resolve(urlObj);
      };
      img.onerror = function () {
        window.SUPPORT_WEBP = false;
        resolve(urlObj);
      };
      img.src =
        "data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA";
    }
  });
}

export function formatWebpParams(urlObj, quality = 75) {
  let cdnReg = /^(https|http):\/\/[a-zA-Z0-9]+\.(max-c|maxjia)\.com/;
  if (window.SUPPORT_WEBP) {
    if (typeof urlObj === "object") {
      Object.keys(urlObj).forEach((key) => {
        if (cdnReg.test(urlObj[key])) {
          let url = urlObj[key].split("?")[0];
          urlObj[key] = `${url}?imageMogr2/format/webp/quality/${quality}`;
        }
      });
    } else if (urlObj) {
      if (cdnReg.test(urlObj)) {
        let url = urlObj.split("?")[0];
        urlObj = `${url}?imageMogr2/format/webp/quality/${quality}`;
      }
    }
  }
  return urlObj;
}

export function moveElementToFront(array, index) {
  if (index > -1) {
    const target = array.splice(index, 1)[0];
    array.unshift(target);
  }
  return array;
}

export function uint8arrayToBase64(u8Arr) {
  let CHUNK_SIZE = 0x8000; //arbitrary number
  let index = 0;
  let length = u8Arr.length;
  let result = "";
  let slice;
  while (index < length) {
    slice = u8Arr.subarray(index, Math.min(index + CHUNK_SIZE, length));
    result += String.fromCharCode.apply(null, slice);
    index += CHUNK_SIZE;
  }
  // web image base64图片格式: "data:image/png;base64," + b64encoded;
  return "data:image/png;base64," + btoa(result);
  // return btoa(result);
}

// 递归遍历子组件，返回指定name的子组件
export function findChildComponents(components, name) {
  // 获取所有tooltip组件
  let tooltipComponents = [];
  // 遍历所有子组件
  components.forEach((component) => {
    if (component.$options.name === name) {
      tooltipComponents.push(component);
    }
    // 递归查找子组件的子组件
    if (component.$children.length > 0) {
      const childTooltipComponents = findChildComponents(
        component.$children,
        name
      );
      tooltipComponents = tooltipComponents.concat(childTooltipComponents);
    }
  });
  return tooltipComponents;
}

export function getQueryStr(queryObj) {
  return Object.entries(queryObj)
    .map(([key, val]) => {
      return `${key}=${val}`;
    })
    .join("&");
}

export function setAwaitChannel(channel_id, password, msg_id) {
  if (channel_id) {
    const await_channel = {
      channel_id: channel_id,
    };
    if (password) {
      await_channel.password = password;
    }
    setStorage("await_enter_channel", await_channel);
    if (msg_id) {
      setStorage("await_jump_msg", {
        channel_id,
        msg_id,
      });
    }
  }
}

// 执行小程序的protocol
export const executeMp = (data) => {
  const {
    bit,
    name,
    need_client,
    protocol,
    mini_pro_id,
    img,
    desc,
    report_type,
  } = data
  updateRecentMp(data)
  // web端组队工具不通过小程序打开
  if((name === '组队工具' || mini_pro_id === 'team_center') && !Vue.prototype.isClient) {
    router.push({name: 'team-center'})
    return
  }
  Vue.prototype.$protocol(
    protocol,
    { 
      bit,
      name,
      need_client,
      mini_pro_id,
      reportObj: {
        id: mini_pro_id,
        type: report_type,
      },
      dialogObj: {
        name,
        img,
        desc
      },
    },
  );
};

export function updateRecentMp(data) {
  const is_use = ((data.need_client && process.env.IS_CLIENT) || !data.need_client)
  const mini_pro_id = data.mini_pro_id
  reportRecentUserMp({mini_pro_id, is_use}).then(({ data }) => {
    if (data.status === 'ok') {
      // 消除某个小程序红点时，判断要不要消除顶部平台红点
      store.commit('SET_USER_ACCOUNT_SETTINGS', {
        miniprogram_platform_red_point: data.result.miniprogram_platform_red_point,
      })
      EventBus.$emit('Clear_Mini_Plat_Red', mini_pro_id)
    }
  })
  if (is_use && !data.not_change_recent_use) {
    store.commit('SET_NEW_RECENT_MINI_PRO', data)
  }
}

// 判断是否为空对象
export const isEmptyObject = (obj) => {
  if(!obj) return true
  return Object.keys(obj).length === 0
};

// 不区分大小写的字符串比较
export const compareString = (str1, str2, is_trim = false) => {
  if (is_trim) {
    str1 = str1.trim();
    str2 = str2.trim();
  }
  return str1.toLowerCase() === str2.toLowerCase();
};

// 不区分大小写的字符串包含
export const includeString = (str1, str2, is_trim) => {
  if (is_trim) {
    str1 = str1.trim();
    str2 = str2.trim();
  }
  return str1.toLowerCase().includes(str2.toLowerCase());
};

// 获取最长公共子序列
export const getLongestCommonSubstring = (str1, str2) => {
  const m = str1.length;
  const n = str2.length;
  if(!m || !n || m === 1 || n === 1) return ''
  let dp = Array.from({ length: m + 1 }, () => Array(n + 1).fill(0));
  let maxLength = 0;
  let endIndex = 0;

  for (let i = 1; i <= m; i++) {
      for (let j = 1; j <= n; j++) {
          if (str1[i - 1] === str2[j - 1]) {
              dp[i][j] = dp[i - 1][j - 1] + 1;
              if (dp[i][j] > maxLength) {
                  maxLength = dp[i][j];
                  endIndex = i;
              }
          } else {
              dp[i][j] = 0;
          }
      }
  }

  const longestCommonSubstr = str1.substring(endIndex - maxLength, endIndex);
  return longestCommonSubstr;
}

/**
 * 小黑盒时间格式化函数
 * @param {number | string} timestamp 
 */
export const heyboxTimeFormat = (timestamp) => {
  const SECOND_IN_MILLIS = 1000;
  const MINUTE_IN_MILLIS = SECOND_IN_MILLIS * 60;
  const HOUR_IN_MILLIS = MINUTE_IN_MILLIS * 60;
  const DAY_IN_MILLIS = HOUR_IN_MILLIS * 24;
  const WEEK_IN_MILLIS = DAY_IN_MILLIS * 7;

  const nowDate = new Date();
  const now = nowDate.getTime();
  const diff = timestamp - now;
  const date = new Date(timestamp);
  const hourStr = date.getHours().toString().padStart(2, '0');
  const minuteStr = date.getMinutes().toString().padStart(2, '0');

  if (diff < MINUTE_IN_MILLIS) {
    return '即将开始';
  } else if (diff < HOUR_IN_MILLIS) {
    return `${Math.floor(diff / MINUTE_IN_MILLIS)} 分钟后开始`;
  } else if (diff < DAY_IN_MILLIS) {
    const isSameDay = nowDate.toDateString() === date.toDateString();
    if (isSameDay) {
      return `${hourStr}:${minuteStr}`;
    } else {
      return `明天 ${hourStr}:${minuteStr}`;
    }
  } else if (diff < WEEK_IN_MILLIS) {
    const weekDays = ['日', '一', '二', '三', '四', '五', '六'];
    const timeStampDays = date.getDay();
    const nowDays = nowDate.getDay();
    if (timeStampDays > nowDays || timeStampDays === 0) {
      return `本周${weekDays[timeStampDays]} ${hourStr}:${minuteStr}`;
    } else {
      return `${
        date.getMonth() + 1
      }.${date.getDate()} ${hourStr}:${minuteStr}`;
    }
  } else {
    const nowDateYear = nowDate.getFullYear();
    const dateYear = date.getFullYear();
    if (nowDateYear === dateYear) {
      return `${date.getMonth() + 1}.${date.getDate()} ${hourStr}:${minuteStr}`;
    } else {
      return `${dateYear}.${
        date.getMonth() + 1
      }.${date.getDate()} ${hourStr}:${minuteStr}`;
    }
  }
};

// 检测是否为准星邀请码
export function checkIsCrosshairShareCode (content) {
  if (!content) return false;
  if (/^\d+$/.test(content) || /^ch\w+$/.test(content)) {
    return content;
  }
  const matches = content.match(CROSSHAIR_SHARE_CODE_REG);
  if (matches) {
    for (let match of matches) {
      let code = match.split("/").pop();
      if (/^\d+$/.test(code) || /^ch\w+$/.test(code)) {
        return code;
      }
    }
  }
  return false;
}

const FAKE_USER_AVATAR_BG = [
  '#26C990',
  '#2A97DC', 
  '#2D7D46',
  '#4567FF',
  '#5FC926',
  '#97A7C9',
  '#DA36FF',
  '#F2BE00',
  '#FF2FA3',
  '#FF333A',
  '#FF9500',
]

function getLastTwoDigits(input) {
  const str = String(input);          // 转换为字符串
  const lastTwo = str.slice(-2);      // 截取最后两位字符
  return parseInt(lastTwo, 10) || 0;  // 转换为整数（空字符串返回0）
}

export function getFakeUserAvatarBg(key, index) {
  let randomIndex
  if (key === undefined || index === undefined) {
    randomIndex = Math.floor(Math.random() * FAKE_USER_AVATAR_BG.length)
  } else {
    randomIndex = (getLastTwoDigits(key) + index) % FAKE_USER_AVATAR_BG.length;
  }
  return FAKE_USER_AVATAR_BG[randomIndex]
}

/**
 * 判断元素是否在容器内
 * @param {HTMLElement} el // 需要判断的元素
 * @param {HTMLElement} container // 容器
 * @param {number} threshold // 阈值，默认0，表示元素完全在容器内才算，负数表示元素有一部分在容器内就算
 * @returns 
 */
export function isInViewPort(el, container, threshold = 0) {
  if (!el || !container) return false
  const rect = el.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  // 检查元素是否在容器的可视区域内
  return (
    rect.bottom > containerRect.top - threshold &&
    rect.top < containerRect.bottom + threshold &&
    rect.right > containerRect.left - threshold &&
    rect.left < containerRect.right + threshold
  )
}

export function getTwEmojiUrl (emoji_code) {
  const codePoints = Array.from(emoji_code).map(c => c.codePointAt(0).toString(16).toLowerCase());
  let code = ''
  // 特殊情况处理
  if (codePoints.includes('20e3')) {
    // 键帽表情（数字和符号）
    code = codePoints.filter(code => code !== 'fe0f').join('-');
  } else if (codePoints.length === 2 && codePoints[1] === 'fe0f') {
    // 单个符号+变体选择器的情况
    code = codePoints[0];
  } else {
    // 其他情况，保持原样
    code = codePoints.join('-');
  }
  return `https://static.max-c.com/static/heybox-chat/twemoji/svg/${code}.svg`
}

/**
 *  模版化时间
 *  @param {number | 'now'} time 时间戳
 *  @param {string} format 格式化模板
 *  @returns {string} 格式化后的时间
 * 
 *  @description
 *  规则 
 *  yyyy是整年份如2022, yy是最后两位如 2022年就是22
 *  mm为个位月份补0，如 8月就是 08， m就是直接显示月份
 *  d为天数 h为小时 n为分钟 规则与月份相同
 *  time 单位为秒
 *  不传参数默认 按 2022-10-12 10:22 这种格式返回当前时间
 *  time 为 'now' 时可传第二个参数，来格式化当前时间
 */ 
export function formatDateByTemplet (time = 'now', format = 'yyyy-mm-dd hh:nn') {

  
  const _date = time == 'now' ? new Date() : new Date(time * 1000),
    year = _date.getFullYear(),
    month = _date.getMonth() + 1 ,
    day = _date.getDate(),
    hour = _date.getHours(),
    minute = _date.getMinutes(),
    second = _date.getSeconds()

  const formatTime = (num) => {
    if (num < 10) {
      return '0' + num
    } else {
      return num
    }
  }
  let pattern = /(y+)|(m+)|(d+)|(h+)|(n+)|(s+)/g
  let match
  while(match = pattern.exec(format)) {
    let match_word = match[0]
    if (/y/.test(match_word)) {
      if (match_word == 'yy') {
        format = format.replace(match_word, String(year % 100))
      } else {
        format = format.replace(match_word, String(year))
      }
    } else if (/m/.test(match_word)) {
      if (match_word == 'mm') {
        format = format.replace(match_word, formatTime(month))
      } else {
        format = format.replace(match_word, String(month))
      }
    } else if (/d/.test(match_word)) {
      if (match_word == 'dd') {
        format = format.replace(match_word, formatTime(day))
      } else {
        format = format.replace(match_word, String(day))
      }
    } else if (/h/.test(match_word)) {
      if (match_word == 'hh') {
        format = format.replace(match_word, formatTime(hour))
      } else {
        format = format.replace(match_word, String(hour))
      }
    } else if (/n/.test(match_word)) {
      if (match_word == 'nn') {
        format = format.replace(match_word, formatTime(minute))
      } else {
        format = format.replace(match_word, String(minute))
      }
    } else if (/s/.test(match_word)) {
      if (match_word == 'ss') {
        format = format.replace(match_word, formatTime(second))
      } else {
        format = format.replace(match_word, String(second))
      }
    }
  }
  return format
}

// 字符串含字母统一转大写
export function toUpperCaseWithLetter (str) {
  if (!str) return str
  if (/[a-zA-Z]/.test(str)) {
    return str.toUpperCase()
  } else {
    return str
  }
}

// 通过electronAPI获取机器码
export function getMachineId() {
  if(getMachineIdPromise) {
    return getMachineIdPromise
  }
  getMachineIdPromise = new Promise((resolve) => {
    window.electronAPI.getMachineId().then((res) => {
      resolve(res)
    })
  })
  
  return getMachineIdPromise
}

export function formatPastTimeSpec(timestamp) {
  if (!timestamp && timestamp !== 0) return "";
  if (!["string", "number"].includes(typeof timestamp)) return "";
  let ts = parseInt(timestamp);
  const len = ts.toString().length;
  if (len === 10) ts = ts * 1000;

  const now = Date.now();
  const diffMs = Math.max(0, now - ts);
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffMs / 60000);
  const diffHour = Math.floor(diffMs / 3600000);
  const diffDay = Math.floor(diffMs / 86400000);

  const d = new Date(ts);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const date = String(d.getDate()).padStart(2, "0");
  const hour = String(d.getHours()).padStart(2, "0");
  const minute = String(d.getMinutes()).padStart(2, "0");

  const nowD = new Date();
  const todayStart = new Date(
    nowD.getFullYear(),
    nowD.getMonth(),
    nowD.getDate(),
    0, 0, 0, 0
  ).getTime();
  const yesterdayStart = todayStart - 86400000;
  const thisYearStart = new Date(nowD.getFullYear(), 0, 1, 0, 0, 0, 0).getTime();

  if (diffSec < 60) return "刚刚";
  if (diffMin < 60) return `${diffMin}分钟前`;

  if (ts >= todayStart) {
    return `${diffHour}小时前`;
  }

  if (ts >= yesterdayStart && ts < todayStart) {
    return `昨天${hour}:${minute}`;
  }

  if (diffDay >= 2 && diffDay <= 4) {
    return `${diffDay}天前`;
  }

  if (ts >= thisYearStart) {
    return `${month}-${date}`;
  }

  return `${year}-${month}-${date}`;
}

// 获取小黑盒环境信息
let HEYBOX_ENV;
export function getHeyboxEnv() {
  if (HEYBOX_ENV) return HEYBOX_ENV;
  if (window.local_obj && window.local_obj.getHeyboxEnv) {
    // Android
    const temp = window.local_obj.getHeyboxEnv() || '{}';
    HEYBOX_ENV = JSON.parse(temp);
    if (HEYBOX_ENV && HEYBOX_ENV.hasOwnProperty('debug')) {
      HEYBOX_ENV.debug = String(HEYBOX_ENV.debug) === 'true';
    }
  } else {
    // iOS
    HEYBOX_ENV = window.HEYBOX_ENV || {};
  }
  return HEYBOX_ENV;
}

export function isInHeybox() {
  const env = getHeyboxEnv();
  return (env && Object.keys(env).length > 0) || window.location.origin === 'file://';
}

/**
 * 卡片信息消息处理
 * @description 卡片信息消息处理，包括小程序卡片、用户名片、群名片、游戏卡片、活动卡片、分享评论卡片、分享帖子卡片、游戏卡片
 * @returns {string} 卡片信息消息处理后的内容
 * @param {*} message 5号推送
 */
export function cardInfoMessageHandler(message) {
  const contentParser = (message) => {
    const messageCpt = MESSAGE_CONTENT_COMPONENT(message)
    if (messageCpt === MESSAGE_COMPONENT_TYPE.TOOL_CARD) {
      return message.tool_card?.header?.title ?? ''
    } else if (messageCpt === MESSAGE_COMPONENT_TYPE.INFO_CARD) {
      return message.info_card?.title ?? ''
    } else if (messageCpt === MESSAGE_COMPONENT_TYPE.COMMENT_CARD) {
      return message.comment_card_v2?.title ?? ''
    } else if (messageCpt === MESSAGE_COMPONENT_TYPE.HEYBOX_GAME_CARD) {
      return message.game_card?.game_name ?? ''
    } else {
      return message.msg_content
    }
  }
  const prefixParser = (message) => {
    const msgType = message.msg_type
    let prefix = ''
    let needContent = true
    switch(msgType) {
      case IM_MSG_TYPE.heyboxMiniProgramCard:
        prefix = '[小程序]'
        break
      case IM_MSG_TYPE.personalBusinessCard:
        prefix = '[用户名片]'
        break
      case IM_MSG_TYPE.groupChatBusinessCard:
        prefix = '[群名片]'
        break
      case IM_MSG_TYPE.gameDetailCard:
        prefix = '[游戏]'
        break
      case IM_MSG_TYPE.activityCard:
        prefix = '[活动]'
        break
      case IM_MSG_TYPE.commentCard:
        prefix = message.comment_card_v2?.source?.game_score !== undefined ? "[游戏评价]" : "[分享评论]"
        needContent = false
        break
      case IM_MSG_TYPE.bbsArticleCard:
        prefix = '[分享帖子]'
        needContent = false
        break
      case IM_MSG_TYPE.heyboxGameCard:
        prefix = '[游戏]'
        break
    }
    return `${prefix}${needContent ? ' ' : ''}`
  }
  return `${prefixParser(message)}${contentParser(message)}`
}
